import axiosInstance from "../../helpers/api";

export const getUserData = () => {
  return axiosInstance.get(`/userInfo`);
};

export const getNotifications = (id) => {
  console.log(id, "noty");
  return axiosInstance.get(`/students/reports/messages/${id}`);
};

export const getGovernorates = () => {
  return axiosInstance.get(`/user/governorates`);
};

export const getMajors = () => {
  return axiosInstance.get(`/asquera_practice/majors`);
};

export const getGrades = () => {
  return axiosInstance.get(`/asquera_practice/grades`);
};

export const getUserGroups = (subject_id) => {
  return axiosInstance.get(`/asquera/groups/${subject_id}`);
};